// extracted by mini-css-extract-plugin
module.exports = {"main":"BBAccordion_main__2C_mY","list":"BBAccordion_list__2df03","firstItemBold":"BBAccordion_firstItemBold__2azKn","link":"BBAccordion_link__1BMRW"};